import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {

  const initialFormState = {
    user_name: '',
    user_email: '',
    message: '',
  };

  const [formData, setFormData] = useState(initialFormState);

  const form = useRef();

  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_c5sutqp', 'template_4hv4pb8', form.current, {
      publicKey: 'h4JTkVrjuF3snle1q',
    })
    .then(
      () => {
        console.log('SUCCESS!');
        form.current.reset(); // Clear the form after successful submission

        setSubmissionSuccess(true);
      },
      (error) => {
        console.log('FAILED...', error.text);
        
        setErrorMessage(error.text);
      },
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

    // Derive form validity directly during render
  // Returns true if any field is empty or contains only whitespace
  const isFormInvalid = Object.values(formData).some((value) => !value.trim());


  const handleClear = (e) => {
    e.preventDefault(); // Prevents page reload if button is inside a form
    setFormData(initialFormState);  
    setSubmissionSuccess(false); // Reset submission success state
    setErrorMessage('');
  };  

  return (
    <form className="center-form" ref={form} onSubmit={sendEmail} 
        style={{
            border: 'none', 
            height: '25rem',  
            width: '50rem', 
            alignItems: 'center', 

            display: 'flex',
            flexDirection: 'column', // Stacks components vertically
            alignItems: 'center',    // Centers components horizontally
            justifyContent: 'center', // Centers components vertically
            // minHeight: '100vh',      // Takes up full viewport height
            gap: '15px',              // Adds spacing between form elements
            margin: '0 auto',        // Centers the form horizontally
        }}>
 
        <div>
            <h2>Contact Form</h2>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '10px' }}>
                <label  style={{ width: '80px', padding: '8px' }} htmlFor="email">Name:</label>
                <input name="user_name" type="text" value={formData.user_name} onChange={handleInputChange} placeholder="Input name" style={{ width: '25rem', padding: '8px' }} />
            </div>


            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '10px' }}>
                <label  style={{ width: '80px', padding: '8px' }} htmlFor="email">Email:</label>
                <input type="email" name='user_email' value={formData.email} onChange={handleInputChange} placeholder="Email" style={{ width: '25rem', padding: '8px' }} />
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '10px' }}>
                <label  style={{ width: '80px', padding: '8px' }} htmlFor="email">Message:</label>
                <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Input message" style={{ width: '25rem', height: '150px', padding: '8px' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginBottom: '10px', justifyContent: 'center' }}>
                {/* <input type="submit" value="Send" style={{float: 'right', border: '1px solid grey', borderRadius: '0.6rem', fontSize: '1.3rem', width: '5.5rem'}} />  */}
                 <button type="button" onClick={handleClear}  className='button-send'>Clear</button>
                              {/* style={{cursor: 'pointer', float: 'right', border: '1px solid grey', borderRadius: '0.6rem', fontSize: '1.3rem', width: '5.5rem'}}>Clear</button> */}
                <input type="submit" value="Send" disabled={isFormInvalid} className='button-send' />
                 {/* style={{cursor: 'pointer', float: 'right', border: '1px solid grey', borderRadius: '0.6rem', fontSize: '1.3rem', width: '5.5rem'}} />  */}
            </div>            

            

        </div>
 
        {submissionSuccess ? (
            <div style={{ color: 'green', fontSize: '1.6rem' }}>
                &#10004; Message sent successfully!
            </div>
            ) : errorMessage ? (
                <div>Failed to send message. Please try again.</div>
            ) : (<div></div>)
        }

    </form>
  );
};

export default ContactForm;